import $ from 'jquery';
import Popover from 'gears/ui/popover/component';

function PopoverInitializer(selector) {
  $(selector).on('click', '.js-popover, [data-popover]', function (e) {
    var $this = $(this);
    if (!$this.data(Popover.namespace)) {
      e.preventDefault();
      return new Popover($this).show(e);
    }
  });
}

export default PopoverInitializer;
